export default "__VITE_ASSET__BIs9nFcl__"